// Dependecies
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
// Store
import user from './store/user';
import locale from './store/locale';

// Hooks
import useLoadData from './hooks/useLoadData';

// 3.3
function PrivateRoute({ Component, componentName, path, t, ...rest }) {
  const [userStore, userAction] = user();
  const [localeStore] = locale();
  const [localStore, setLocalStore] = useState(
    localStorage.leo ? JSON.parse(localStorage.leo) : { token: undefined }
  );

  useLoadData(componentName);

  useEffect(() => {
    userAction.setAuth();
  }, []);

  useEffect(() => {
    if (userStore.rol === 3 && userStore.token) {
      userAction.getPackagesCompany().then(() => {});
    }
  }, [userStore.rol]);

  useEffect(() => {
    userAction.getUser().then(() => {});
  }, [path]);

  useEffect(() => {
    if (userStore.isLoaded) {
      if (userStore.token !== localStore.token) {
        setLocalStore({ ...userStore });
      }
    }
  }, [userStore.token]);

  return (
    <Route
      path={path}
      {...rest}
      render={(props) =>
        localStore.token || userStore.token ? (
          <Component {...props} />
        ) : (
          <Redirect
            from="/"
            to={{
              pathname: `/${localeStore.currentLocale}/${t('Login')}`,
              state: {
                prevLocation: path,
                error: t('menu:error'),
              },
            }}
          />
        )
      }
    />
  );
}

PrivateRoute.propTypes = {
  Component: PropTypes.elementType.isRequired,
  componentName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
};

export default withTranslation(['routers', 'menu'])(withRouter(PrivateRoute));
